import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import style from './RejectAppointmentModal.module.css'
import { Header } from 'components/header/Header'
import { AppButton, ButtonTheme } from 'components/app-button/AppButton'
import { Input } from 'features/resource/userProfileStylesMui'

type RejectAppointmentProps = {
  handleRejectSubmit: (cancelMessage: string | undefined) => void
  handleClose: () => void
}

export const RejectAppointmentModal = (props: RejectAppointmentProps): JSX.Element => {
  const { t } = useTranslation()
  const [message, setMessage] = useState<string>('')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value)
  }

  return (
    <div className={style.parentContainer}>
      <Box className={style.newConversationContainer}>
        <Header label={t('rejectAppointment')} />
        <Box>
          <Typography className={style.inputTitle}>{t('rejectReason')}</Typography>
          <Input
            key={'rejectReason'}
            value={message}
            type="text"
            required
            size={'small'}
            onChange={handleChange}
          />
        </Box>
        <form>
          <Box display={'flex'} justifyContent={'center'} />
          <Box
            display={'flex'}
            justifyContent={'center'}
            width={'100%'}
            style={{ marginTop: '8%' }}
          >
            <Box mr={4}>
              <AppButton
                theme={ButtonTheme.NewSecondary}
                type={'button'}
                label={t('close')}
                handler={props.handleClose}
              />
            </Box>
            <AppButton
              theme={ButtonTheme.NewPrimary}
              type={'button'}
              label={t('send')}
              handler={() => props.handleRejectSubmit(message)}
            />
          </Box>
        </form>
      </Box>
    </div>
  )
}
